import type { ObjectGraph } from '@jet/environment/dependencies';
import type { ClassicalAPIResponse } from './types';

import { requestClassicalAPIResource } from '../utilities/requestClassicalAPIResource';
import { ClassicalAPIURL } from './ClassicalAPIURL';

export async function requestPostAction(
    query: string,
    payload: unknown,
    objectGraph: ObjectGraph,
): Promise<ClassicalAPIResponse> {
    const url = new ClassicalAPIURL(`${query}`, objectGraph);

    const bodyContent = JSON.stringify(payload);
    return requestClassicalAPIResource(
        {
            url: url.string,
            body: bodyContent,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        },
        objectGraph,
    );
}
